module.exports = __webpack_public_path__ + "icomoon.10d1627.ttf";